export default "__VITE_PUBLIC_ASSET__affaeaba__"